import { set200Toast, toastErrorState, pageErrorState } from '../actions/uiActions/responseStateActions';
import { AppDispatch } from '../store';

export const interceptErrorWithToastMessage =
  <Args, Returns>(
    apiAsyncMethod: (args: Args, config: { dispatch: AppDispatch }) => Promise<Returns>,
    successMessage?: string,
    showPageErrorState?: boolean
  ) =>
  async (args: Args, { dispatch }: any): Promise<Returns> => {
    try {
      const result = await apiAsyncMethod(args, { dispatch });
      if (successMessage) {
        dispatch(set200Toast(successMessage));
      }
      return result;
    } catch (e) {
      showPageErrorState
        ? dispatch(pageErrorState(e.status, e.message))
        : dispatch(toastErrorState(e.status, e.message));
      throw e;
    }
  };
